import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { IoLocationOutline, IoCallOutline, IoMailOutline } from 'react-icons/io5';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const categories = [
        { name: "Dry Fruit Box", path: "/products" },
        { name: "Fancy MDF Box", path: "/products" },
        { name: "Fancy Kappa Box", path: "/products" },
        { name: "Sweet Box", path: "/products" },
    ];

    const quickLinks = [
        { name: "Home", path: "/" },
        { name: "About", path: "/about" },
        { name: "Products", path: "/products" },
        { name: "Contact", path: "/contact" },
    ];

    return (
        <footer className="bg-[#f8ecdf] text-brand-dark pt-20 border-t border-brand-brown/10">
            <div className="container-x">
                <div className="grid grid-cols-1 lg:grid-cols-11 gap-10 lg:gap-4 pb-16">

                    {/* LEFT SIDE (Brand Section) */}
                    <div className="lg:col-span-4">
                        <div className="mb-8">
                            <Logo />
                        </div>

                        <p className="text-[15px] leading-relaxed text-brand-dark/80 mb-8 max-w-sm font-medium">
                            Famous Packing has been creating premium packaging since 1990.
                            We focus on quality, clean design, and products people trust
                            for every occasion.
                        </p>

                        <div className="flex gap-4">
                            {[FaFacebookF, FaInstagram, FaLinkedinIn].map((Icon, i) => (
                                <a
                                    key={i}
                                    href="#!"
                                    className="w-10 h-10 border border-brand-brown/30 flex items-center justify-center text-brand-brown hover:bg-brand-brown hover:text-white transition-all duration-300"
                                >
                                    <Icon size={16} />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* RIGHT SIDE (3 EQUAL COLUMNS - Now pulled closer) */}
                    <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-8">

                        {/* Categories */}
                        <div>
                            <h4 className="text-brand-brown text-[13px] font-bold tracking-[0.2em] uppercase mb-6 border-b border-brand-brown/20 pb-2 inline-block">
                                Categories
                            </h4>
                            <ul className="space-y-4">
                                {categories.map((item, i) => (
                                    <li key={i}>
                                        <Link to={item.path} className="text-[15px] text-brand-dark hover:text-brand-brown font-normal">
                                            {item.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Quick Links */}
                        <div>
                            <h4 className="text-brand-brown text-[13px] font-bold tracking-[0.2em] uppercase mb-6 border-b border-brand-brown/20 pb-2 inline-block">
                                Quick Links
                            </h4>
                            <ul className="space-y-4">
                                {quickLinks.map((item, i) => (
                                    <li key={i}>
                                        <Link to={item.path} className="text-[15px] text-brand-dark hover:text-brand-brown font-normal">
                                            {item.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Reach Us */}
                        <div>
                            <h4 className="text-brand-brown text-[13px] font-bold tracking-[0.2em] uppercase mb-6 border-b border-brand-brown/20 pb-2 inline-block">
                                Reach Us
                            </h4>
                            <ul className="space-y-5 font-normal">
                                <li className="flex gap-3">
                                    <IoLocationOutline size={20} className="text-brand-brown mt-1 shrink-0" />
                                    <span className="text-[15px]">Shop No 50 - 51 B Wing Sahayog Shopping Center Mumbra Thane 400612</span>
                                </li>

                                <li className="flex gap-3">
                                    <IoCallOutline size={20} className="text-brand-brown shrink-0" />
                                    <span className="text-[15px]">+91 9819676460</span>
                                </li>

                                <li className="flex gap-3">
                                    <IoMailOutline size={20} className="text-brand-brown shrink-0" />
                                    <span className="text-[15px]">info@famouspacking.com</span>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>

                {/* BOTTOM BAR */}
                <div className="border-t border-brand-brown/10 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-[13px] text-brand-dark/60 tracking-wider font-medium">
                    <p>© {currentYear} Famous Packing. All rights reserved.</p>
                    <p className="uppercase">ESTABLISHED 1990 · MUMBAI, INDIA</p>
                </div>

            </div>
        </footer>
    );
};

export default Footer;